import { Avatar, Pagination } from "@mui/material";
import Box from "elements/Box";
import { CiWavePulse1 } from "react-icons/ci";
import BlogEditor from "./BlogEditor";
import { useEffect, useState } from "react";
import { ApiRequest } from "GlobalFunctions";
import React from "react";
import { Link } from "react-router-dom";
import Banner from "elements/Banner";

const formatDate = (dateStr: string) => {
    if (!dateStr) return '';
    const d = new Date(dateStr.replace(' ', 'T'));
    return d.toLocaleDateString('es-CL', { year: 'numeric', month: 'long', day: 'numeric' });
};

export default function GlobalBlog() {

    const [openEditor, setOpenEditor] = useState(false);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);

    const [list, setList] = useState([]);
    const loadList = async () => {
        ApiRequest({
            url: '/blog/globalList',
            method: 'GET',
            query: {
                page: page
            },
            setResponse: (response: any) => {
                setList(response.list);
                setTotalPages(response.total_pages);
            }
        });
    }

    useEffect(() => {
        loadList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [page]);

    return (
        <>
        <Banner section="blog" />
        <div className="content">
             <div className='blog_title_row'>
                <h2 className='titles'><CiWavePulse1 size={25} />Blog</h2>
            </div>


            <div className="blog_entries">
                {list.length > 0 && list.map((blog: any, index: number) => (
                    <Box key={index} className='blog_entry'>
                        <div className='blog_entry_header'>
                            <Link 
                                to={`/${blog.alias}`} 
                                className="blog_link"
                                onClick={(e) => {
                                    e.preventDefault();
                                    window.location.href = `/${blog.alias}`;
                                }}
                            >
                                <h2>{blog.title}</h2>
                            </Link>
                            <span className="blog_date">{formatDate(blog.created_at)}</span>
                        </div>
                        <div className='short_blog_content'>
                            
                            {blog.image &&
                                <img src={blog.image} alt={blog.title} />
                            }
                            
                            <div className="short_blog_content_text">
                                
                                <p className="p_short_content" dangerouslySetInnerHTML={{ __html: blog.short_content }}></p>
                                
                                <div className="blog_author">
                                    <Link className="blog_author_link" to={`/kinesiologos/${blog.user_id}`}>
                                        <span>Por: {blog.author}</span>
                                        <Avatar src={blog.user_image} />
                                    </Link>
                                </div>

                                
                            </div>
                        </div>
                        
                    </Box>
                ))}
            </div>
            {totalPages > 1 && (
                <div className="pagination_container">
                    <Pagination 
                        count={totalPages} 
                        page={page}  
                        onChange={(event, value) => {
                            setPage(value);
                            const mainContent = document.getElementById('main_content');
                            if (mainContent) {
                                mainContent.scrollTo({ top: 0, behavior: 'smooth' });
                            }
                        }} 
                        color="primary"
                        style={{"marginTop": "20px","alignSelf": "center"}}
                    />
                </div>
            )}
        </div>

        <BlogEditor open={openEditor} setOpen={setOpenEditor} loadList={loadList} />
        </>
    );
}
